import type { GuildIdRange } from "../../types/experiment";
import { Input } from "../ui/input";
import { Label } from "../ui/label";

interface GuildIdRangeFilterProps {
  value: GuildIdRange;
  onChange: (value: GuildIdRange) => void;
}

export function GuildIdRangeFilter({ value, onChange }: GuildIdRangeFilterProps) {
  return (
    <div className="flex gap-3">
      <div>
        <Label className="mb-1 block text-xs">Min ID</Label>
        <Input
          value={value.min_id?.value ?? ""}
          onChange={(e) =>
            onChange({
              ...value,
              min_id: e.target.value ? { value: e.target.value } : undefined,
            })
          }
          placeholder="snowflake"
        />
      </div>
      <div>
        <Label className="mb-1 block text-xs">Max ID</Label>
        <Input
          value={value.max_id?.value ?? ""}
          onChange={(e) =>
            onChange({
              ...value,
              max_id: e.target.value ? { value: e.target.value } : undefined,
            })
          }
          placeholder="snowflake"
        />
      </div>
    </div>
  );
}
